export const capitalizeString = (string) => string.charAt(0).toUpperCase() + string.slice(1);
